import React, { Component } from 'react';
import Switch from "react-switch";
import axios from 'axios';

/* Images */
import astroSilo from '../../assets/silo/astro.png';
import wakandaSilo from '../../assets/silo/wakanda.png';
import tianaSilo from '../../assets/silo/tiana.png';
import fillmoreSilo from '../../assets/silo/fillmore.png';

const baseUrl = (window.location.href.indexOf("localhost") > -1 ? "http://localhost:3001" : "");

class NotificationCenter extends Component{
    constructor(props) {
        super(props);

        this.state = {
            notificationList:[],
            selectedNotification:0, percentDone: 0,
            lastUptDt: null, timerFlg: false,
            toggleSettings: false, settingSearch:"",
            searchType:0, activeSettings: [{id:1, img: fillmoreSilo},{id:2, img: tianaSilo},{id:3, img: wakandaSilo},{id:4, img: astroSilo}], 
            settingsSearchResults:[],
            notificationSettings: null
        }

        this.viewTimer = 0;
        this.notiTimer = null;

        this.toggleSettings = this.toggleSettings.bind(this);
        this.getLastDtFormat = this.getLastDtFormat.bind(this);
        this.connectToCenter = this.connectToCenter.bind(this);
        this.buildNotification = this.buildNotification.bind(this);
        this.changeSelected = this.changeSelected.bind(this);
        this.startTimer = this.startTimer.bind(this);
        this.dismissNotifications = this.dismissNotifications.bind(this);
        this.closeNotificationCenter = this.closeNotificationCenter.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.handleSwitchChange = this.handleSwitchChange.bind(this);
        this.getUserNotificationSettings = this.getUserNotificationSettings.bind(this);
        this.getSearchResults = this.getSearchResults.bind(this);
        this.editSearchResult = this.editSearchResult.bind(this);
        this.saveNotificationSettings = this.saveNotificationSettings.bind(this);
    }

    toggleSettings(status){
        try {
            this.setState({ toggleSettings: status });
        }
        catch(ex){
            console.log("[Error] Toggling Settings: ",ex);
        }
    }

    getLastDtFormat(){
        try {
            var ret = "";
            if(this.state.lastUptDt != null){
                var curDt = new Date();
                var dtDiff = (curDt.getTime() - this.state.lastUptDt.getTime()) / (60 * 1000);

                ret = Math.ceil(dtDiff) + " minutes ago";
            }
        }
        catch(ex){
            console.log("[Error] getting Last Date Format: ",ex);
        }

        return ret;
    }

    connectToCenter(){
        try {
            var self = this;
            const userToken = this.props.checkUser(false,false);
            if(!userToken) { console.log("[Warning] No Token For Notification Connection");}
            else {
                var eSource = new EventSource(baseUrl +'/api/notificationCenter/'+userToken);

                eSource.onmessage = function(e){
                    var msgData = JSON.parse(e.data);
                    if(msgData.error){
                        console.log("[Error] Getting Notification: ", msgData.error);
                    }
                    else if(msgData.results){
                        var tmpResults = self.state.notificationList.filter(function(noti){ return noti.dismissed === undefined || !noti.dismissed; });
                        tmpResults = tmpResults.concat(msgData.results);
                        
                        self.setState({ notificationList: tmpResults, timerFlg: false, lastUptDt: new Date() }, ()=>{
                            self.props.updateNotificationList(self.state.notificationList);
                            self.startTimer();
                        });
                    }
                }

                eSource.onerror = function (err) {
                    console.log("NaratifLa-Alerts Conn Issue: ", err);
                }
            }
        }
        catch(ex){
            console.log("[Error] Connection to notification center: ",ex);
        }
    }

    buildNotification(){
        try {
            var selNoti = this.state.notificationList[this.state.selectedNotification];
            switch(selNoti.type) {
                case "fillmore":
                    return <div className="noti-content user fillmore">
                                <div className="icon-container user fillmore"><img src={fillmoreSilo} alt="fillmore silo"/></div>
                                <div className="info-container">{selNoti.data.name + " should be " + selNoti.data.status}</div>
                            </div>; 
                case "tiana":
                    return <div className="noti-content user tiana">
                                <div className="icon-container user tiana"><img src={tianaSilo} alt="fillmore silo"/></div>
                                <div className="info-container">{selNoti.data.info}</div>
                            </div>; 
                case "wakanda":
                    return <div className="noti-content user wakanda">
                                <div className="icon-container user wakanda"><img src={wakandaSilo} alt="fillmore silo"/></div>
                                <div className="info-container">The next pay day for {selNoti.data.name} is in {selNoti.data.days} day(s)</div>
                            </div>; 
                case "astro":
                    return <div className="noti-content user astro">
                                <div className="icon-container user astro"><img src={astroSilo} alt="fillmore silo"/></div>
                                <div className="info-container">{selNoti.data.points} new astro views detected {(selNoti.data.tags.length <= 0 ? "" : " filtering on (" + selNoti.data.tags.join(", ") +")")} </div>
                            </div>; 
                default:
                    return <div>N/A</div>
            }
        }
        catch(ex){
            console.log("[Error] Building Notification: ", ex);
        }
    }

    changeSelected(id){
        try {
            var self = this;
            var nextVal = id, prevVal = this.state.selectedNotification;

            if(id < 0) {
                nextVal = ((this.state.selectedNotification+1) >= this.state.notificationList.length ? 0 : (this.state.selectedNotification+1));
            }

            // Set Flag To Start Timer
            var timerFlg = this.state.timerFlg || !this.props.display || (this.state.selectedNotification+1) >= this.state.notificationList.length;

            // Set Dismissed Value
            var tmpNotiList = this.state.notificationList;
            if(tmpNotiList.length > 0) { tmpNotiList[prevVal].dismissed = true; }

            this.setState({ selectedNotification: nextVal, timerFlg: timerFlg, notificationList: tmpNotiList }, ()=>{
                if(!self.state.timerFlg) { self.startTimer(); }
                else { self.dismissNotifications(); }

                // Update Base Notification List
                self.props.updateNotificationList(self.state.notificationList);
            });
        }
        catch(ex){
            console.log("[Error] Changing Selected Notification: ", ex);
        }
    }

    startTimer(){
        try {
            var self = this;
            this.setState({ percentDone: 0}, ()=>{
                // Reset Timers
                self.viewTimer = 0;

                // Max Time in Sec
                var maxTime = 7 * 1000;

                // Clear Last Interval
                clearInterval(self.notiTimer);

                // Start New Interval Timer
                self.notiTimer = setInterval(function(){ 
                    if(self.viewTimer >= maxTime || !self.props.display){
                        clearInterval(self.notiTimer);
                        if(self.props.display) { self.changeSelected(-1); }
                    }
                    else {
                        self.viewTimer += 100;
                        self.setState({ percentDone: (self.viewTimer / maxTime) * 100 });
                    }
                }, 100);
            });            
        }
        catch(ex){
            console.log("[Error] Starting Notification Timer: ", ex);
        }
    }

    dismissNotifications(){
        try {
            var self = this;
            this.setState({ percentDone: 100 }, ()=>{ 
                clearInterval(self.notiTimer);                
            });
        }
        catch(ex){
            console.log("[Error] Dismiss Notifications Timer: ", ex);
        }
    }

    closeNotificationCenter() {
        try {
            var self = this;
            self.setState({ toggleSettings: false }, ()=>{
                clearInterval(this.notiTimer); 
                self.props.toggleNotification(false);
            });            
        }
        catch(ex){
            console.log("[Error] Closing Notification Center: ",ex);
        }
    }

    handleSearchChange(e){
        try {      
            var self = this;      
            var name = e.target.name;
            this.setState({ [name]: e.target.value }, () =>{
                if(name === "settingSearch" && self.state.settingSearch.length > 0) {
                    self.getSearchResults(self.state.settingSearch, function(ret){
                        self.setState({ settingsSearchResults: ret });
                    });
                }
                else if(self.state.settingSearch.length === 0){
                    self.setState({ settingsSearchResults: [] });
                }
            });            
        }
        catch(ex){
            console.log("[Error] handling search change data: ",ex);
        }
    }

    handleSwitchChange(status, e, id){
        try {
            var tmpId = id.split("-"), self = this;
            var items = this.state.notificationSettings;
            items[tmpId[1]][tmpId[0]] = status;
    
            this.setState({ notificationSettings: items }, ()=> { self.saveNotificationSettings(); });
        }
        catch(ex){
            console.log("[Error] handling switch change data: ",ex);
        }
    }

    getUserNotificationSettings(){
        try {
            var self = this, user = this.props.checkUser(false,false);
            var getHeaders = { 'Content-Type': 'application/json', 'Authorization': user };

            axios.get(baseUrl + "/api/notification/retrieveSettings" , { headers: getHeaders })
                .then(function(response) {
                    if(response.data.error){
                        console.log(" [Error] Getting User Notification Settings: ", response.data.error);
                    }
                    else {      
                        var notifyList = {
                            1:{ typeId: 1, type:"fillmore", dataList: [], active: false },
                            2:{ typeId: 2, type:"tiana", dataList: [], active: false },
                            3:{ typeId: 3, type:"wakanda", dataList: [], active: false },
                            4:{ typeId: 4, type:"astro", dataList: [], active: false },
                        };   
                        
                        if(response.data.results) {
                            response.data.results.forEach(function(item){ notifyList[item.typeId] = item; });
                        }

                        self.setState({ notificationSettings: notifyList });
                    }
                }); 
        }
        catch(ex){
            console.log("[Error] Getting User Notification Settings: ",ex);
        }
    }

    getSearchResults(search, callback){
        try {
            var self = this, user = this.props.checkUser(false,false);
            var getHeaders = { 'Content-Type': 'application/json', 'Authorization': user };
            var selItem = this.state.notificationSettings[this.state.searchType];

            if(selItem.type === "astro"){
                callback([{ id: 0, name: search }]);
            }
            else if(selItem.type === "tiana") {
                callback([]);
            }
            else if(selItem.type === "fillmore" || selItem.type === "wakanda"){ 
                var url = baseUrl + (selItem.type === "fillmore" ? "/api/auth/getUsers" : "/wakanda/retrieveAll");

                axios.get(url, { headers: getHeaders })
                .then(function(response) {
                    if(response.data.error){
                        console.log(" [Error] Getting Search Results: ", response.data.error);
                        self.setState({ loading: false });
                    }
                    else {         
                        var dataRes = response.data.results
                                        .filter(function(info){ return info.name.toLowerCase().indexOf(search.toLowerCase()) >= 0; })
                                        .map(function(mapinfo) { return { id: mapinfo._id, name: mapinfo.name }});
                        
                        callback(dataRes);
                    }
                }); 
            }
        }
        catch(ex){
            console.log("[Error] Get Search Results: ",ex);
        }
    }

    editSearchResult(item, type){
        try {
            var self = this, settingList = this.state.notificationSettings;
            
            if(type === "add"){
                if(settingList[this.state.searchType].dataList.map(function(e) { return e.name; }).indexOf(item.name) < 0) {
                    settingList[this.state.searchType].dataList.push(item);
                }
            }
            else {
                settingList[this.state.searchType].dataList = settingList[this.state.searchType].dataList.filter(function(dtItem) { return dtItem.name !== item.name});
            }

            this.setState({ notificationSettings: settingList, settingSearch:"" }, () =>{ self.saveNotificationSettings(); });
        }
        catch(ex){
            console.log("[Error] adding search result: ",ex);
        }
    }

    saveNotificationSettings(){
        try {
            const self = this, user = this.props.checkUser(false,false);
            const postData = { notifications: Object.keys(this.state.notificationSettings).map(function(item){ return self.state.notificationSettings[item]; }) };
            const getHeaders = { 'Content-Type': 'application/json', 'Authorization': user };

            axios.post(baseUrl + "/api/notification/updateSettings", postData, { headers: getHeaders })
            .then(function(response) {
                if(response.data.error){
                    console.log(" [Error] Getting Random Recipe Results: ", response.data.error);
                }
                else {
                    console.log("Updating Notification Settings: ",response.data.results); 
                }
            });   
        }
        catch(ex){
            console.log("[Error] Saving Notification Settings: ",ex);
        }
    }

    componentDidMount(){
        this.getUserNotificationSettings();
        this.connectToCenter();
    }

    render(){        
        return(
            <div className={"notification-container" + (this.props.display ? " open" : "" )}>
               <div className="top-container">
                   <div className="ctrl-noti-container">
                        <div className="ctrl-container" onClick={()=> { this.setState({ toggleSettings: !this.state.toggleSettings })}}><i className="fas fa-cog"/></div>
                        <div className="ctrl-container" onClick={this.closeNotificationCenter}><i className="fas fa-times"/></div>
                   </div>
                   {(this.state.notificationList.length === 0 ? 
                        <div className="noti-content empty">
                            <div className="icon-container"><i className="fas fa-box-open"/></div>
                            <div className="info-container">No current notifications</div>
                        </div> 
                        : this.buildNotification()
                   )}
                   <div className="lastDt">{this.getLastDtFormat()}</div>
               </div>
               <div className="bottom-container">
                   {this.state.notificationList.length > 0 && 
                        <div className={"noti-timer " + this.state.notificationList[this.state.selectedNotification].type} style={{ width: this.state.percentDone+"%" }}/>
                   }
                   <div className="tick-container">
                       {this.state.notificationList.length === 0 && <div className="tick empty" />}
                       {this.state.notificationList.map((noti,i) => <div className={"tick" + (this.state.selectedNotification === i ? " sel" : "") + (noti.dismissed ? " dismissed" : "")} key={i} onClick={()=> this.changeSelected(i)} /> )}
                   </div>
                   <div className={"tick-ctrl" + (this.state.notificationList.length === 0 ? " disabled" :"")} onClick={()=> this.changeSelected(-1)}><i className="fas fa-angle-right" /></div>
               </div>

               {this.state.toggleSettings &&
                    <div className="settings-container">
                        <div className="section-title">Notification Settings</div>

                        <div className={"search-container" + (this.state.searchType > 0 ? "":" disabled")}>
                            <i className="fas fa-search" />
                            <input type="text" name="settingSearch" autoComplete="off" value={this.state.settingSearch} onChange={this.handleSearchChange} disabled={this.state.searchType === 0}/>
                            {(this.state.settingsSearchResults.length > 0 && this.state.searchType > 0 && this.state.settingSearch.length > 0) &&
                                <div className="results-panel">
                                    {this.state.settingsSearchResults.map((item, k) =>
                                        <div className="panel-row" key={k} onClick={() => this.editSearchResult(item, "add")}>{item.name}</div>
                                    )}
                                </div>
                            }
                        </div>

                        {this.state.notificationSettings && this.state.activeSettings.map((setting,i)=>
                            <div className={"setting-section" + (this.state.searchType === setting.id ? " sel" :"")}  key={i} onClick={()=> this.setState({ searchType: setting.id })}>
                                <div className="section-row">
                                    <div className={"icon-container user " + this.state.notificationSettings[setting.id].type}><img src={setting.img} alt={this.state.notificationSettings[setting.id].type + " silo"} /></div>
                                    <div className="setting-title">{this.state.notificationSettings[setting.id].type}</div>
                                    <Switch className="setting-switch" id={"active-"+setting.id} checked={this.state.notificationSettings[setting.id].active} onChange={this.handleSwitchChange} height={20} />  
                                </div>
                                {(this.state.searchType === setting.id && this.state.notificationSettings[setting.id].dataList.length > 0) &&
                                    <div className="section-row tags">
                                        {this.state.notificationSettings[setting.id].dataList.map((item,j)=>
                                            <div className="list-tag" key={j}>
                                                <span>{item.name}</span>
                                                <i className="fas fa-times" onClick={() => this.editSearchResult(item, "del")}/>
                                            </div>
                                        )}
                                    </div>
                                }
                            </div>
                        )}                        
                    </div>
               }
            </div>
        );        
    }    
}

export default NotificationCenter;